import { Box } from '@mui/material';
import React from 'react';
import { GlobalAudioPlayer } from '../components/GlobalAudioPlayer';
import { StudioFooter } from '../components/StudioFooter';
import { useStudioUnauthenticatedContext } from '../context/StudioContext';
import { NavigationSection } from '../pages/studio/Dashboard/sections/NavigationSection';

interface StudioPageProps {
  children: React.ReactNode;
}

export const StudioPage: React.FC<StudioPageProps> = ({ children }) => {
  const { playerState } = useStudioUnauthenticatedContext();
  const hasPlayer = Boolean(playerState.playingItem);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Navigation sidebar */}
      <NavigationSection />

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0, // Allow flex item to shrink so content (e.g. Catalog table) doesn't overflow viewport
          display: 'flex',
          flexDirection: 'column',
          pb: hasPlayer ? 10 : 0, // Prevent footer/content from being hidden behind the player
        }}
      >
        <Box sx={{ flexGrow: 1, minHeight: 0 }}>{children}</Box>
        <StudioFooter />
      </Box>

      {/* Global Audio Player */}
      <GlobalAudioPlayer />
    </Box>
  );
};
